import { render } from "./SurveyResultsModal.vue?vue&type=template&id=bec72164&scoped=true"
import script from "./SurveyResultsModal.vue?vue&type=script&lang=js"
export * from "./SurveyResultsModal.vue?vue&type=script&lang=js"

import "./SurveyResultsModal.vue?vue&type=style&index=0&id=bec72164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec72164"]])

export default __exports__